import {
  UNITS_NONE,
  UNITS_IMPERIAL,
  UNITS_METRIC,
} from '../constants/textModes';

const _createMeasurementFormatter = (
  valueLargeSignifier,
  valueSmallSignifier,
) => (valueLarge = 0, valueSmall = 0) => {
  const zeroLg = valueLarge === '' || parseFloat(valueLarge) === 0;
  const zeroSm = valueSmall === '' || parseFloat(valueSmall) === 0;

  return [
    !zeroLg ? `${valueLarge}${valueLargeSignifier}` : null,
    zeroLg || !zeroSm ? `${valueSmall}${valueSmallSignifier}` : null,
  ]
    .filter((s) => !!s)
    .join(' ');
};

const measurementToStringMetric = _createMeasurementFormatter('m', 'cm');
const measurementToStringImperial = _createMeasurementFormatter(`'`, `"`);

const parseMeasurement = (text) => {
  let matches;

  // Match the pattern `##' ##"`
  matches = /^(\d*\.?\d*)'[\s]*(\d*\.?\d*)"$/.exec(text);
  if (matches) {
    return { units: UNITS_IMPERIAL, valueFt: matches[1], valueIn: matches[2] };
  }

  // Match the pattern `##'`
  matches = /^(\d*\.?\d*)'$/.exec(text);
  if (matches) {
    return { units: UNITS_IMPERIAL, valueFt: matches[1], valueIn: 0 };
  }

  // Match the pattern `##"`
  matches = /^(\d*\.?\d*)"$/.exec(text);
  if (matches) {
    return { units: UNITS_IMPERIAL, valueFt: 0, valueIn: matches[1] };
  }

  // Match the pattern `##m ##cm`
  matches = /^(\d*\.?\d*)m[\s]*(\d*\.?\d*)cm$/.exec(text);
  if (matches) {
    return { units: UNITS_METRIC, valueM: matches[1], valueCm: matches[2] };
  }

  // Match the pattern `##m`
  matches = /^(\d*\.?\d*)m$/.exec(text);
  if (matches) {
    return { units: UNITS_METRIC, valueM: matches[1], valueCm: 0 };
  }

  // Match the pattern `##cm`
  matches = /^(\d*\.?\d*)cm$/.exec(text);
  if (matches) {
    return { units: UNITS_METRIC, valueM: 0, valueCm: matches[1] };
  }

  // No match
  return { units: UNITS_NONE };
};

export {
  measurementToStringMetric,
  measurementToStringImperial,
  parseMeasurement,
};
